
import React, { Component } from 'react';
import { Modal, Button, Descriptions } from 'antd';

const fields = [{
    "text": "会员名称",
    "field": "name",
},{
    "text": "会员编号",
    "field": "memberCode",
},  {
    "text": "充值类型",
    "field": "type",
}, {
    "text": "充值金额",
    "field": "amount",
}, {
    "text": "赠送方案",
    "field": "giftSchemeDict",
    "agentRecharge": true
}, {
    "text": "赠送金额",
    "field": "giftAmount",
    "agentRecharge": true
}, {
    "text": "总金额",
    "field": "totalAmount",
    "agentRecharge": true
}, {
    "text": "备注",
    "field": "remark",
}, {
    "text": "审核状态",
    "field": "status",
    format: { 0: '待审核', 1: '审核通过', 2: '审核不通过' }
}, {
    "text": "创建人",
    "field": "creator",
}, {
    "text": "审核人",
    "field": "auditor"
}, {
    "text": "审核时间",
    "field": "auditTime",
}, {
    "text": "审核备注",
    "field": "auditMind",
}, {
    "text": "充值时间",
    "field": "insertTime",
}];


class FinancialAuditDetail extends Component {
    render() {
        const { visible, onCancel, editData } = this.props;
        return (
            <Modal
                width={900}
                visible={visible}
                title="充值信息详情"
                maskClosable={false}
                onCancel={onCancel}
                footer={[
                    <Button key="take" type="primary" onClick={onCancel}>确定</Button>,
                ]}
            >
                <Descriptions title="" bordered column={2}>
                    {fields.map((item, index) => {
                        let val = editData[item.field]
                        if (item.format) {
                            val = item.format[val];
                        }
                        if (editData["giftSchemeDict"]) {
                            return <Descriptions.Item key={index} label={item.text}>{val}</Descriptions.Item>;
                        }
                        else if (item.agentRecharge){
                            return "";
                        }
                        return <Descriptions.Item key={index} label={item.text}>{val}</Descriptions.Item>;
                    })}
                </Descriptions>
            </Modal>
        );
    }
}


export default FinancialAuditDetail;